import {Component, OnDestroy, OnInit, QueryList, ViewChildren} from "@angular/core";
import {FormBuilder} from "@angular/forms";
import {MultiDropdownComponent} from "../../../../shared/components/form-controls/multi-dropdown/multi-dropdown.component";
import {ProductCollectionsEnum} from "../../../../shared/enums/product-collections.enum";
import {DropdownOptionModel} from "../../../../shared/models/components/form-controls/dropdown-option.model";
import {FieldAliases} from "../../../constants/fieldAliases";
import {HlaCollectionFilterForm} from "../../../forms/hla-collection-filter.form";
import {HlaCollectionParamsFilterModel} from "../../../models/search-params/filters/hla-collection-params-filter.model";
import {SuggestionsSearchModel} from "../../../models/suggestions-search.model";
import {CollectionSearchConfigService} from "../../../services/collection-search-config.service";
import {CollectionSearchParamsFactoryService} from "../../../services/factories/collection-search-params-factory.service";
import {SuggestionsService} from "../../../services/suggestions.service";
import {CollectionFilterDirective} from "../collection-filter.directive";

@Component({
    selector: "pcg-ng-hla-collection-filter",
    template: require('./hla-collection-filter.component.html')
})
export class HlaCollectionFilterComponent extends CollectionFilterDirective<HlaCollectionFilterForm, HlaCollectionParamsFilterModel> implements OnInit, OnDestroy {
    @ViewChildren(MultiDropdownComponent)
    private multiDropdowns: QueryList<MultiDropdownComponent>;

    public IHW_NUMBER_ALIAS: string = FieldAliases.HLA_COLLECTION.IHW_NUMBER;

    public serologicalOptions: Array<DropdownOptionModel> = new Array<DropdownOptionModel>();
    public dnaProbeOptions: Array<DropdownOptionModel> = new Array<DropdownOptionModel>();
    public nonHlaGenesOptions: Array<DropdownOptionModel> = new Array<DropdownOptionModel>();

    public constructor(
        private searchConfigService: CollectionSearchConfigService,
        formBuilder: FormBuilder,
        searchParamsFactory: CollectionSearchParamsFactoryService,
        suggestionsService: SuggestionsService,
    ) {
        super(formBuilder, searchParamsFactory, suggestionsService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.serologicalOptions = this.searchConfigService.getSerologicalOptions();
        this.dnaProbeOptions = this.searchConfigService.getDnaProbeOptions();
        this.nonHlaGenesOptions = this.searchConfigService.getNonHlaGenesOptions();
    }

    public searchForiHWNumberSuggestions(value: string): void {
        const params = new SuggestionsSearchModel(ProductCollectionsEnum.ECACCHLA, FieldAliases.HLA_COLLECTION.IHW_NUMBER, value);
        this.searchForSuggestions(params);
    }
    public clearForm(): void {
       super.clearForm();
       this.multiDropdowns.forEach(x => x.clear());
    }

    protected createFilterForm(): HlaCollectionFilterForm {
        return HlaCollectionFilterForm.createForm(this.formBuilder, this.filter, this.searchParamsFactory);
    }
}
